import axios from "axios";
import Cookies from "js-cookie";

let API_BASE = "https://www.buglog.app/api/v1";

export const setApiBase = (url) => {
  API_BASE = url;
  api.defaults.baseURL = url;
};

export const getApiBase = () => api.defaults.baseURL || API_BASE;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

const tokenParam = () => {
  const t = Cookies.get("token");
  return t ? { token: t } : {};
};

const stripUndefined = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null)
  );

export const get = async (url, params = {}) =>
  (await api.get(url, { params: { ...stripUndefined(params), ...tokenParam() } }))
    .data;

export const post = async (url, data = {}) =>
  (await api.post(url, { ...stripUndefined(data), ...tokenParam() })).data;

export const put = async (url, data = {}) =>
  (await api.put(url, { ...stripUndefined(data), ...tokenParam() })).data;

export const del = async (url, data = {}) => {
  try {
    const res = await api.delete(url, {
      data: { ...stripUndefined(data), ...tokenParam() },
    });
    return res.data;
  } catch (err) {
    const status = err?.response?.status;
    const payload = err?.response?.data;
    console.error("DEL ERROR:", { url, status, payload });
    return {
      status: "error",
      message:
        (typeof payload === "string" && payload) ||
        payload?.message ||
        payload?.error ||
        (status ? `HTTP ${status}` : err.message || "Unknown error"),
      payload,
    };
  }
};

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      e.message ||
      "İstek başarısız";
    return Promise.reject(new Error(msg));
  }
);
